// extracted by mini-css-extract-plugin
module.exports = {"ui2":"var(--ui2)","vocalsAndLyrics":"LyricsFilter_vocalsAndLyrics___BbQx","lyrics":"LyricsFilter_lyrics__0s4YQ","buttonContainer":"LyricsFilter_buttonContainer__OZKfb"};